import * as generic_helpers from './generic_helper';
import * as entity_helpers from './entities_helper';



export default {
  generic: generic_helpers,
  entity: entity_helpers
}
